import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../components/ui/dialog'
import { useDialogStore } from '../../../store/dialogStore'
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { Form } from '../../../components/ui/form'
import LinkForm from './LinkForm'
import { Button } from '../../../components/ui/button'
import { useQueryClient } from '@tanstack/react-query'
import { linksQueryKey } from '../queries/linksQuery'
import { useToast } from '../../../components/ui/use-toast'
import { Api } from '../../../lib/axios'
import { useEffect } from 'react'
import { useSharedStore } from '../../../store/sharedStore'
import { useEditLinkMutation } from '../mutations/editLinkMutation'

const formSchema = z
  .object({
    nameKz: z.string({ required_error: 'Толтыруға міндетті' }).trim().max(60, { message: 'Атауы 60 символдан аса болмасын' }),
    uri: z.string({ required_error: 'Толтыруға міндетті' }).url('URL енгізіңіз'),
  })

export default function EditLinkDialog() {
  const queryClient = useQueryClient()

  const open = useDialogStore(state => state.open)
  const setOpen = useDialogStore(state => state.setOpen)

  const form = useForm<z.infer<typeof formSchema>>({
    mode: 'onChange',
    resolver: zodResolver(formSchema),
  })

  const selectedLink = useSharedStore(state => state.selectedLink)

  useEffect(() => {
    if (selectedLink) {
      form.setValue('nameKz', selectedLink.nameKz)
      form.setValue('uri', selectedLink.uri)
    }
  }, [selectedLink, open])

  const { mutateAsync, error, isPending } = useEditLinkMutation()
  const { toast } = useToast()

  const submit = async (data: z.infer<typeof formSchema>) => {
    await mutateAsync({ ...data, id: selectedLink?.id ?? 0 })
    void queryClient.invalidateQueries({ queryKey: [linksQueryKey] })
    toast({
      description: 'Нормативтік құқықтық акт өзгертілді',
      variant: 'success',
    })
    setOpen(null)
  }

  return (
    <Dialog open={open === 'EditLink'} onOpenChange={() => setOpen(null)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Нормативтiк құқықтық актiнің қосу</DialogTitle>
        </DialogHeader>

        {Api.isAxiosError(error) && (
          <span className="text-sm text-destructive">
            {error?.response?.data?.responseClientMessage}
          </span>
        )}

        <Form {...form}>
          <form onSubmit={form.handleSubmit(submit)}>
            <LinkForm />

            <Button
              className="w-full mt-5"
              type="submit"
              loading={isPending}
            >
              Қабылдау
            </Button>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  )
}
